import { Routes, Route, Outlet } from "react-router-dom";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Technology from "./pages/Technology";
import Apps from "./pages/Apps";
import VisualMotivator from "./pages/VisualMotivator";
import VisualMotivatorPrivacy from "./pages/VisualMotivatorPrivacy";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about-us" element={<About />} />
          <Route path="projects" element={<Projects />} />
          <Route path="contact-us" element={<Contact />} />
          <Route path="technology/:slug" element={<Technology />} />
          <Route path="app" element={<Outlet />}>
            <Route index element={<Apps />} />
            <Route path="visual-motivator" element={<Outlet />}>
              <Route index element={<VisualMotivator />} />
              <Route path="privacy" element={<VisualMotivatorPrivacy />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
